import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class RedirectionService {
  hostname = window.location.hostname;
  port = window.location.port;
  constructor() {}

  redirectToInvestorPortal(path: string = "") {
    let redirectionURL = "https://investonline.itiamc.com/"; // Default: Production

    switch (true) {
      case this.hostname.includes("localhost"):
      case this.hostname.includes("jeethweb.robosoftin.com"):
        // Localhost or SIT Environment
        redirectionURL = "https://jeethinvestor.robosoftin.com/";
        break;
      case this.hostname.includes("dev.itiamc.com") && this.port === "8485":
        // UAT Environment
        redirectionURL = "https://devinvestor.itiamc.com/";
        break;
      case this.hostname.includes("devv2.itiamc.com") && this.port === "8485":
        // New UAT Environment
        redirectionURL = "https://devinvestorv2.itiamc.com/";
        break;
    }

    window.open(`${redirectionURL}${path}`, "_blank");
  }

  redirectToDistributorPortal(path: string = "") {
    let redirectionURL = "https://itimfpartners.itiamc.com/"; // Default: Production

    switch (true) {
      case this.hostname.includes("localhost"):
      case this.hostname.includes("jeethweb.robosoftin.com"):
        // Localhost or SIT Environment
        redirectionURL = "https://jeeth.robosoftin.com/";
        break;
      case this.hostname.includes("dev.itiamc.com") && this.port === "8485":
        // UAT Environment
        redirectionURL = "https://dev.itiamc.com/";
        break;
      case this.hostname.includes("devv2.itiamc.com") && this.port === "8485":
        // New UAT Environment
        redirectionURL = "https://devv2.itiamc.com/";
        break;
    }

    window.open(`${redirectionURL}${path}`, "_blank");
  }
}
